
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlCopyUserToOtherHotelsRequest } from "../models/service-models/user/CopyUserToOtherHotelsRequest";
import { mdlCopyUserToOtherHotelsResponse } from "../models/service-models/user/CopyUserToOtherHotelsResponse";
import { mdlUserCreateRequest } from "../models/service-models/user/UserCreateRequest";
import { mdlUserCreateResponse } from "../models/service-models/user/UserCreateResponse";
import { mdlUserDeleteRequest } from "../models/service-models/user/UserDeleteRequest";
import { mdlUserDeleteResponse } from "../models/service-models/user/UserDeleteResponse";
import { mdlUserDetailRequest } from "../models/service-models/user/UserDetailRequest";
import { mdlUserDetailResponse } from "../models/service-models/user/UserDetailResponse";
import { mdlUserListRequest } from "../models/service-models/user/UserListRequest";
import { mdlUserListResponse } from "../models/service-models/user/UserListResponse";
import { mdlUserPermissionListRequest } from "../models/service-models/user/UserPermissionListRequest";
import { mdlUserPermissionListResponse } from "../models/service-models/user/UserPermissionListResponse";
import { mdlUserPermissionListUpdateRequest } from "../models/service-models/user/UserPermissionListUpdateRequest";
import { mdlUserPermissionListUpdateResponse } from "../models/service-models/user/UserPermissionListUpdateResponse";
import { mdlUserUpdateRequest } from "../models/service-models/user/UserUpdateRequest";
import { mdlUserUpdateResponse } from "../models/service-models/user/UserUpdateResponse";
import { GetResponse } from "../utils/ApiClient";
import {mdlBaseRequest} from "../models/service-models/common/BaseRequest";
import {mdlBaseOperationResponse} from "../models/service-models/common/BaseOperationResponse";

module UtilsService {
    export async function ClearCache(
        pRequest: mdlBaseRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "utils/clear-cache",
            pRequest
        );
    }

}

export { UtilsService };